import { render, staticRenderFns } from "./AdvancedSettings.vue?vue&type=template&id=8648c4e6&scoped=true"
import script from "./AdvancedSettings.vue?vue&type=script&lang=ts"
export * from "./AdvancedSettings.vue?vue&type=script&lang=ts"
import style0 from "./AdvancedSettings.vue?vue&type=style&index=0&id=8648c4e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8648c4e6",
  null
  
)

export default component.exports